// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-00bf22fc]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.ed-aside[data-v-00bf22fc]{flex:0 0 240px;border-bottom:1px solid #eee;overflow-y:auto;margin-right:16px}.ed-body[data-v-00bf22fc]{flex:1;overflow-x:hidden}.main[data-v-00bf22fc]{display:flex;margin-top:20px}", ""]);
// Exports
module.exports = exports;
